<template>
  <div>
    <h3>欢迎登录展商服务平台！</h3>
    <el-card class="box-card">
      <div class="text item">
        {{ userInfo.atrName }}
      </div>
      <div class="text item">展位号：{{ userInfo.bthCode || '暂无' }}</div>
    </el-card>
    <ul>
      <li>
        <p>展商服务平台现已开通，帮助您更好地准备展前工作。该系统提供的服务有：</p>
        <ol>
          <li>1.展商信息收集</li>
          <li>2.展商服务申请</li>
          <li>3.新品上传</li>
        </ol>
      </li>
      <li>阅读平台相关信息，并遵守各项服务的截止日期，部分标有“必填”字样的内容请优先填写。</li>
      <li>对于各项服务申请，您只需线上正确填写。若有任何问题，请联系表格中指定的负责人或主办方。</li>
      <li>我们期待着您的到来。祝您在展会上取得成功！</li>
      <li>为保护您的信息安全，30分钟未操作，系统将自动注销。</li>
      <br />
      <strong> 今天是{{ today }}， 距离展会开幕还有 {{ inDays }}。 </strong>
    </ul>
    <el-divider></el-divider>
    <el-table :data="infoTable" style="width: 100%">
      <el-table-column prop="fstName" label="项目" ></el-table-column>
      <el-table-column label="重要性">
        <template slot-scope="scope">
          <span>{{ scope.row.isRequired ? '必填项' : '非必填' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="fstEDate" label="截止日期">
        <template slot-scope="scope">
          <span>{{ format(scope.row.fstEDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subDate" label="提交日期">
        <template slot-scope="scope">
          <span>{{ format(scope.row.subDate) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      exhInfo: {},
      today: moment().format('YYYY年MM月DD日'),
      inDays: '',
      infoTable: []
    }
  },
  methods: {
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    }
  },
  mounted() {
    api.getexhinfo().then((res) => {
      this.inDays = moment(res.data.data.exhbtime).toNow(true)
    })

    api.getformsetting().then((res) => {
      this.infoTable = res.data.data
    })
  }
}
</script>

<style lang="less" scoped>
.box-card {
  margin: 20px 0 20px 0;
}
.item {
  padding: 18px 0;
  font-size:14px
}
li, strong {
  line-height: 2;
  font-size:14px;
}
.page-warp h3{
  font-size:14px
}
@media screen and (max-width:540px){

}
</style>
